import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Rocket, Star, MessageSquare, TrendingUp, Zap, Activity, Award
} from 'lucide-react';
import { API } from './shared';

const iconMap = {
  rocket: Rocket, star: Star, 'message-circle': MessageSquare,
  'trending-up': TrendingUp, zap: Zap, activity: Activity, award: Award
};

const colorMap = {
  amber: 'text-amber-500 bg-amber-50', purple: 'text-purple-500 bg-purple-50',
  blue: 'text-blue-500 bg-blue-50', pink: 'text-pink-500 bg-pink-50',
  orange: 'text-orange-500 bg-orange-50', green: 'text-green-500 bg-green-50',
  yellow: 'text-yellow-500 bg-yellow-50'
};

export const BadgeIcon = ({ badge }) => {
  const Icon = iconMap[badge.icon] || Award;
  const colors = colorMap[badge.color] || colorMap.purple;
  return (
    <div className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${colors}`} title={badge.description}>
      <Icon className="h-3 w-3" />{badge.name}
    </div>
  );
};

const MemberBadgesInline = ({ communityId, userId }) => {
  const [badges, setBadges] = useState([]);
  useEffect(() => {
    if (!communityId || !userId) return;
    axios.get(`${API}/communities/${communityId}/badges/${userId}`, { withCredentials: true })
      .then(r => setBadges(r.data.badges || []))
      .catch(() => {});
  }, [communityId, userId]);

  if (badges.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-2" data-testid={`badges-${userId}`}>
      {badges.map(b => <BadgeIcon key={b.id} badge={b} />)}
    </div>
  );
};

export default MemberBadgesInline;
